import logoIcon from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom"; // use this if using react-router

const Header = () => {
  const navigate = useNavigate(); // React Router navigation hook
  const user_type = localStorage.getItem("user_type");

  const handleLogout = () => {
    localStorage.clear(); // Clear all stored data
    navigate("/login"); // Redirect to login page
  };

  return (
    <header
      className="bg-black border-b-2 text-white h-16 sticky top-0 right-0 left-0 px-6 z-50 shadow-xl flex items-center justify-between"
      id="header-container"
    >
      {/* Logo */}
      <div className="w-28">
        <img src={logoIcon} alt="Logo" className="w-full" />
      </div>

      {user_type == `"Candidate"` ? (
        <></>
      ) : (
        <div>
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm"
          >
            Logout
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
